import { useContext } from "react";
import { AppContext } from "../App";
import s1 from "../assets/trans.jpg";
import s2 from "../assets/fabrication.jpg";
import s3 from "../assets/construction.png";
import { MdOutlineArrowOutward } from "react-icons/md";

export default function FeaturedProducts() {
  const appContext = useContext(AppContext);

  const services = [
    {
      id: "transport",
      title: "Transportation",
      subtitle: "Coordinated delivery for construction materials and approved project goods across Tanzania.",
      image: s1,
      cta: "Arrange Transport",
      onClick: () => appContext.navTo({ item: "contact_us" }),
    },
    {
      id: "fabrication",
      title: "Fabrication",
      subtitle: "Made-to-order construction accessories tailored to project specifications.",
      image: s2,
      cta: "Work with Us",
      onClick: () => appContext.navTo({ item: "request_quote" }),
    },
    {
      id: "materials",
      title: "Supply of Construction Materials",
      subtitle: "Reliable sourcing of structural, finishing, and external works materials.",
      image: s3,
      cta: "Order Materials",
      onClick: () => appContext.navTo({ item: "products" }),
    },
  ];

  return (
    <div className="support-services-wrap mt-5">
      <div className="container">
        <div
          className="support-services-head text-center mx-auto"
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-offset="140"
        >
          <p className="support-services-eyebrow text-primary">Additional Services</p>
          <h3 className="support-services-title font-semi-bold">Support services that keep projects moving</h3>
          <p className="support-services-subtitle">
            Transportation, fabrication, and material supply delivered with practical coordination.
          </p>
        </div>

        <div className="support-services-grid">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="support-services-card"
              data-aos="fade-up"
              data-aos-duration="900"
              data-aos-delay={index * 110 + 60}
            >
              <div className="support-services-image-wrap">
                <div className="support-services-image"><img src={service.image} style={{width:"100%"}}/></div>
              </div>
              <div className="support-services-body">
                <h4 className="support-services-card-title">{service.title}</h4>
                <p className="support-services-card-text">{service.subtitle}</p>
                <button className="btn support-services-btn" onClick={service.onClick}>
                  {service.cta} <MdOutlineArrowOutward size={17} className="flex-shrink-0" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>

      <style>{`
        .support-services-wrap {
          padding: 64px 0 68px;
          background:
            radial-gradient(circle at 92% 14%, rgba(27, 108, 165, 0.08), transparent 34%),
            linear-gradient(180deg, #f8fbfe 0%, #f2f7fb 100%);
          font-family: "FontRegular", "Segoe UI", sans-serif;
        }

        .support-services-head {
          max-width: 760px;
          margin-bottom: 26px;
        }

        .support-services-eyebrow {
          margin: 0 0 8px;
          font-size: 18px !important;
          text-transform: uppercase;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .support-services-title {
          margin: 0 0 10px;
          font-size: 24px;
          line-height: 1.25;
          color: #112f4a;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .support-services-subtitle {
          margin: 0;
          font-size: 15px;
          line-height: 1.7;
          color: #4b5f72;
        }

        .support-services-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 16px;
        }

        .support-services-card {
          border-radius: 18px;
          border: 1px solid #e2ebf2;
          background: #ffffff;
          box-shadow: 0 12px 28px rgba(16, 43, 67, 0.08);
          display: flex;
          flex-direction: column;
          padding: 12px;
          transition: transform 0.24s ease, box-shadow 0.24s ease;
        }

        .support-services-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 18px 34px rgba(16, 43, 67, 0.14);
        }

        .support-services-image-wrap {
          border-radius: 12px;
          overflow: hidden;

        }

        .support-services-image {
          height: 300px;
          background-size: cover;
          background-position: center;
        }

        .support-services-body {
          padding: 14px 8px 8px;
          display: flex;
          flex-direction: column;
          gap: 11px;
          height: 100%;
        }

        .support-services-card-title {
          margin: 0;
          font-size: 19px;
          line-height: 1.35;
          color: #143650;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
        }

        .support-services-card-text {
          margin: 0;
          font-size: 14px;
          line-height: 1.7;
          color: #506579;
          flex-grow: 1;
        }

        .support-services-btn {
          align-self: flex-start;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          border: 1px solid #1e628e;
          background: #1f6d9a;
          color: #ffffff;
          border-radius: 999px;
          padding: 10px 18px;
          font-size: 14px;
          font-family: "FontSemiBold", "Segoe UI", sans-serif;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .support-services-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(30, 98, 142, 0.25);
          color: var(--surfaceColor);
        }

        @media (max-width: 991px) {
          .support-services-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 767px) {
          .support-services-wrap {
            padding: 52px 0;
          }

          .support-services-title {
            font-size: 22px;
          }

          .support-services-grid {
            grid-template-columns: 1fr;
          }

          .support-services-image {
            min-height: 160px;
          }
        }
      `}</style>
    </div>
  );
}
